import gql from 'graphql-tag';

export const UPLOAD_INVOICE = gql`
  mutation UploadInvoice($input: UpsertDocumentInput!, $file: Upload) {
    upsertDocument(input: $input, file: $file)
  }
`;
